import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { CarCard } from "@perxis-auto/ui-kit/lib/components/CarCard";
const CardLocation = memo(function CardLocation2({ location, isLoading = false, ...props }) {
  if (isLoading) {
    return /* @__PURE__ */ jsx(CarCard.LocationSkeleton, {});
  }
  if (!location) {
    return null;
  }
  return /* @__PURE__ */ jsx(CarCard.Location, { location, ...props });
});
export {
  CardLocation
};
